module.exports = __webpack_public_path__ + "assets/img/en-38270d27.png";